import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import SEOHead from './SEOHead';

const DynamicMeta = () => {
  const { pathname } = useLocation();
  const [meta, setMeta] = useState<Record<string, string>>({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchMeta = async () => {
      try {
        setIsLoading(true);
        const id = pathname.split('/').pop();

        if (pathname.includes('/database/') && id) {
          const { data, error } = await supabase
            .from('animatronics')
            .select('name, description, media')
            .eq('id', id)
            .single();

          if (error) throw error;

          if (isMounted && data) {
            setMeta({
              // Just use the name without appending site name
              title: data.name,
              description: data.description
                ? data.description.slice(0, 160)
                : 'Explore the world of animatronics at Animatronic Database.',
              image: data.media?.[0]?.url || '/android-chrome-512x512.png',
            });
          }
        }
      } catch (error) {
        console.error('Error fetching meta:', error);
        if (isMounted) {
          setMeta({});
        }
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    fetchMeta();

    return () => {
      isMounted = false;
    };
  }, [pathname]);

  // Only render SEOHead for database detail pages
  if (isLoading || !pathname.includes('/database/')) {
    return null;
  }

  return (
    <SEOHead
      title={meta.title}
      description={meta.description}
      image={meta.image}
      type="article"
    />
  );
};

export default DynamicMeta;